import React from 'react';
import type { Control } from 'react-hook-form';
import { OdinController } from '@myosh/odin-components';
import RiskLevel from './risk-level.component';
import type { RiskLevelProps } from './risk-level.component';

interface HfRiskRatingProps extends RiskLevelProps {
  control?: Control;
  name?: string;
  saveMatrix?: () => void;
}

const HfRiskLevel = ({ control, name, readOnly, label, riskMatrixId, saveMatrix }: HfRiskRatingProps) => {
  return (
    <OdinController
      name={name as string}
      control={control}
      render={() => <RiskLevel riskMatrixId={riskMatrixId} label={label} readOnly={readOnly} saveMatrix={saveMatrix} />}
    />
  );
};

export default HfRiskLevel;
